import { render, staticRenderFns } from "../templates/cattleLog.pug?vue&type=template&id=91ff104c&scoped=true&lang=pug&"
import script from "./CattleLog.vue?vue&type=script&lang=js&"
export * from "./CattleLog.vue?vue&type=script&lang=js&"
import style0 from "./CattleLog.vue?vue&type=style&index=0&id=91ff104c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ff104c",
  null
  
)

export default component.exports